module.exports = __webpack_public_path__ + "static/images/icon-mail.29a17546a5914a0171a02e5272264e11.svg";